import { RTCClient } from './chat-connection';

var rtcClient;

const RTC = () => {
  if (!window.RTC.init) {
    rtcClient = RTCClient();
  }
  const _subscribe = options => {
    let subscribedChannelsList = rtcClient.client.getSubscribedChannels();
    // it is to check the requested current channel is already subscribed or not
    let checkingAlreadySubscribedChannels = subscribedChannelsList.filter(
      element => options?.channels?.includes(element)
    );

    const runSubscribe = () => {
      let args = {
        channels: options.channels,
        ...options.callbacks
      };
      if (options.meta) {
        args.meta = options.meta;
      }
      rtcClient.client.Subscribe(args);

      const existing = window.RTC.subscribedChannels || [];
      const toAdd = (options.channels || []).filter(
        channel => !existing.includes(channel)
      );
      if (toAdd.length) {
        rtcClient.pushSubscribedChannels(toAdd);
      }
    };

    const dropLocalChannels = () => {
      const channels = options.channels || [];
      window.RTC.subscribedChannels = (
        window.RTC.subscribedChannels || []
      ).filter(channel => !channels.includes(channel));
    };

    const alreadySubscribed = checkingAlreadySubscribedChannels.length > 0;
    const shouldSubscribe =
      rtcClient?.status &&
      (!alreadySubscribed || options.forcePickupSubscribe);

    if (shouldSubscribe && options.forcePickupSubscribe && alreadySubscribed) {
      rtcClient.client.UnSubscribe({
        channels: options.channels,
        onSuccess: () => {
          dropLocalChannels();
          runSubscribe();
        },
        onFailure: () => {
          dropLocalChannels();
          runSubscribe();
        }
      });
    } else if (shouldSubscribe) {
      runSubscribe();
    }

    // Note: recall subscribe function if status is false to resubscrbe the channel
    if (!rtcClient?.status) {
      setTimeout(() => {
        if (
          checkingAlreadySubscribedChannels.length === 0 ||
          options.forcePickupSubscribe
        ) {
          _subscribe(options);
        }
      }, 1000);
    }
  };

  const _publish = options => {
    options.retries = options.retries || 0;
    options.meta = options.meta || {};
    if (options.channels) {
      options.channels = options.channels;
    }
    if (options.channel) {
      options.channel = options.channel;
    }
    options.data = options.data || {};
    let args = {
      ...options,
      ...options.callbacks
    };

    rtcClient.client.Publish(args);
  };
  const _unsubscribe = (channels, callbacks) => {
    rtcClient.client.UnSubscribe({
      channels: channels,
      ...(callbacks || {})
    });
  };
  return {
    Subscribe: _subscribe,
    Publish: _publish,
    UnSubscribe: _unsubscribe
  };
};

export default RTC;
